import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { FiCheck } from 'react-icons/fi';
import { checkboxField } from '@lib/form';
import PropTypes from 'prop-types';
import { FIELD_BORDER_COLOR } from '../formTheme';
import getFieldStatus from '../fieldStatus';

const BOX_SX = {
  width: 22,
  height: 22,
  borderRadius: '6px',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default function CheckBoxField(props) {
  const {
    name,
    disabled,
    value,
    error,
    touched,
    label = '',
    helperText = '',
    handleChange,
    handleBlur,
    labelPlacement = 'end',
    readOnly,
  } = props;
  const { hasError, message } = getFieldStatus({ error, touched, helperText });

  return (
    <Box>
      <FormControlLabel
        aria-readonly
        control={(
          <Checkbox
            checked={Boolean(value)}
            checkedIcon={(
              <Box sx={{ ...BOX_SX, backgroundColor: 'primary.main', color: 'primary.contrastText' }}>
                <FiCheck size={14} strokeWidth={3} />
              </Box>
            )}
            color="primary"
            disabled={disabled || readOnly}
            icon={(
              <Box
                sx={{
                  ...BOX_SX,
                  border: '1.5px solid',
                  borderColor: hasError ? 'error.main' : FIELD_BORDER_COLOR,
                  backgroundColor: 'common.white',
                }}
              />
            )}
            name={name}
            onBlur={handleBlur}
            onChange={(event) => handleChange(event.target.checked)}
          />
        )}
        label={label}
        labelPlacement={labelPlacement}
        slotProps={{
          typography: { sx: { fontSize: 14, lineHeight: 1.45 } },
        }}
        sx={{ alignItems: 'flex-start', mr: 0 }}
      />
      {/* A required, unchecked box used to fail validation with nothing on screen to say so. */}
      {message && (
        <FormHelperText error={hasError}>
          {message}
        </FormHelperText>
      )}
    </Box>
  );
}

CheckBoxField.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  error: PropTypes.string,
  touched: PropTypes.bool,
  label: PropTypes.string,
  helperText: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  labelPlacement: PropTypes.string,
  readOnly: PropTypes.bool,
};

CheckBoxField.getDefaultValue = checkboxField.getDefaultValue;
CheckBoxField.serializeValue = checkboxField.serializeValue;
CheckBoxField.deserializeValue = checkboxField.deserializeValue;
CheckBoxField.getDisplayValue = checkboxField.getDisplayValue;
CheckBoxField.validationSchema = checkboxField.validationSchema;
CheckBoxField.graphQlSchema = `
  typeCheckbox {
    id
    labelPlacement
  }
`;
